// ─────────────────────────────────────────────────────────────────────────────
// 💶 PRIX CATALOGUE MIHI = le « Prix catalogue » affiché sur mihi.care (celui que paie une cliente)
// À ne pas confondre avec le prix barré (ancien prix) ni avec « Votre prix » (prix distributrice / Premium).
// Relevé sur mihi.care le 26/10/2026 (campagne 15-26), 446 produits. Clé = référence sans zéros devant.
// Priorité pour un produit : champ « prixCatalogue » du catalogue importé (colonne Excel « Prix catalogue »),
// puis cette liste, puis le prix enregistré dans le catalogue (« prix »).
// Le prix VIP (Premium Club) = 70 % du prix catalogue : il est recalculé quand le produit est dans la liste.
// ─────────────────────────────────────────────────────────────────────────────

export const PRIX_CATALOGUE = {
  "10107":9.9,"10108":9.9,"10109":7.9,"10110":7.9,"10111":7.9,"10208":9.9,"10209":10.9,"10210":16.9,
  "10211":16.9,"10212":10.5,"10213":10.5,"10401":8.9,"10402":7.9,"10404":8.5,"10405":6.5,"10408":8.9,
  "10409":6.9,"10611":7.9,"10612":8.9,"10613":9.8,"10614":11.9,"10615":9.9,"10702":16.9,"10703":16.9,
  "10705":7.8,"10710":0.9,"10711":0.9,"11103":14,"11200":10.5,"11201":10.5,"11202":11.9,"11405":15.9,
  "11406":15.9,"11407":15.9,"11501":10.5,"11502":11.5,"11600":8.9,"11601":8.9,"11602":7.9,"11700":10.5,
  "11701":10.5,"11702":8.5,"11800":8.9,"11801":8.9,"11802":6.9,"11900":5.7,"11901":6.5,"11902":6.5,
  "12001":23.9,"12002":15.7,"12003":21.9,"12101":17.9,"12102":10.5,"12103":8.9,"12104":12.9,"12201":8.9,
  "12202":8.9,"12203":7.9,"12204":10.9,"20102":12.9,"20106":8.5,"20112":4.9,"20113":9.9,"20114":5.9,
  "20115":6.9,"20116":5.9,"20202":5.5,"20205":5.9,"20207":4.8,"20211":6.9,"20307":6.9,"20308":8.9,
  "20309":11.3,"20611":4.3,"20612":4.5,"20620":6.5,"20621":6.5,"20622":6.5,"20623":3.9,"20624":3.9,
  "20625":6.5,"20626":4.5,"21102":6.5,"21103":6.5,"21104":9.9,"21105":7.9,"21200":8.9,"21201":6.5,
  "21202":9.9,"21203":13.9,"21204":13.9,"21205":11.9,"21301":5.2,"21303":7.8,"21304":9.6,"21400":6.9,
  "21402":7.9,"21403":6.9,"21404":6,"21405":7.9,"21406":8.9,"21500":11.9,"21501":9.9,"21601":1.2,
  "21602":1.2,"21603":1.2,"21604":1.5,"21605":1.2,"21701":7.5,"21702":7.5,"21703":6.9,"21704":5.2,
  "21705":7.9,"21706":7.5,"21707":5.2,"21708":3.5,"21709":3.5,"21710":3.5,"21801":10.9,"21802":18.9,
  "21803":12.9,"21901":13.9,"21902":12.9,"21903":10.9,"21904":15.9,"22101":4.5,"22102":5.5,"22103":4.5,
  "22104":4.5,"30107":0.9,"30108":0.9,"30601":9.9,"30602":5.9,"30603":5.9,"30604":7.9,"30606":9.9,
  "30608":5.9,"30701":6.5,"30702":7.9,"30801":7.9,"30802":7.9,"31001":10.9,"31002":7.9,"31004":9.6,
  "31100":10.1,"31300":9.5,"31301":9.5,"31302":9.5,"31303":8.9,"31304":0.9,"31305":0.9,"31400":6.9,
  "31401":6.9,"31600":14.8,"31601":16.9,"31602":1,"31603":1,"31801":7.9,"31802":7.9,"31803":7.9,
  "31804":6.9,"31805":10.5,"40101":18.5,"40103":18.5,"40104":18.5,"40108":18.5,"40109":17.1,"40110":18.5,
  "40111":18.5,"40112":17.5,"40113":18.5,"40114":22.5,"40117":16.9,"40118":23.9,"40119":31.1,"40201":18.5,
  "40202":18.5,"40204":18.5,"40205":18.5,"40206":18.5,"40207":19.5,"40208":19.8,"40501":22.5,"40502":22.5,
  "40503":22.5,"40504":19.8,"40505":22.5,"40601":18.9,"40602":20.9,"50102":8.9,"50103":9.9,"50104":9.9,
  "50107":10.9,"50204":6.9,"50205":6.9,"50206":6.9,"50207":9.9,"50208":9.9,"50301":5.9,"50302":5.9,
  "50303":5.9,"50305":7.5,"50306":10.9,"50413":12.9,"50414":12.9,"50415":6.5,"50416":6.5,"50417":6.5,
  "50418":6.5,"50419":6.5,"50504":8.5,"50505":8.9,"50507":2.9,"50603":7.9,"50707":10.9,"50708":10.1,
  "50710":7.2,"50715":12.9,"50716":15.9,"50902":3.9,"50904":3.9,"50905":3.9,"50906":3.9,"50907":3.9,
  "50908":3.9,"50909":3.9,"50910":3.9,"50911":4.5,"50912":4.5,"50913":4.5,"51107":7.5,"51108":10.9,
  "51109":8.5,"51110":8.5,"51111":8.5,"51112":8.9,"51113":8.9,"51114":8.9,"51115":8.9,"51116":8.9,
  "51117":8.9,"51118":8.9,"51119":8.9,"51120":8.9,"51201":11.9,"51202":11.9,"51203":11.9,"51204":11.9,
  "51205":11.9,"51206":11.9,"51207":7.8,"51210":11.9,"51211":8,"51212":8,"51213":11.9,"51304":4.8,
  "52002":18.9,"52003":10.9,"52004":10.9,"52005":10.9,"60401":4.9,"60402":4.9,"60403":9.5,"60404":9.5,
  "70101":8.9,"70102":7.9,"70104":10.9,"70107":2.9,"70108":10.9,"70109":10.9,"70110":5.9,"80101":7.9,
  "80102":5.9,"80104":6.9,"80105":4.9,"80106":6.9,"80107":6.5,"80108":5.5,"80109":4.9,"80110":7.5,
  "80113":8.5,"80117":6.9,"80119":6.9,"80120":5.9,"80121":6.5,"80125":5.9,"80126":6.5,"80127":6.5,
  "80128":5.2,"80129":5.9,"80131":6,"80132":6,"80133":7.9,"80135":6.5,"80136":7.9,"80137":1.5,
  "80138":1.5,"80139":7.5,"80140":10.9,"80142":4.3,"80143":6.9,"80144":10.9,"80146":7.9,"80201":11.9,
  "80203":6,"80205":6.9,"80207":6.9,"80208":11.9,"80209":11.9,"80210":11.9,"80211":11.9,"80213":11.9,
  "80214":9.9,"80215":10.9,"80303":15.9,"80304":15.9,"80305":6.9,"80401":2.9,"90101":0.3,"90103":0.3,
  "90104":0.3,"90203":0.2,"90204":1,"90205":0.2,"90206":0.4,"90428":1,"90429":1,"90430":3.3,
  "90539":1.9,"91399":2.5,"91400":2.5,"91401":2.5,"91402":2.5,"91403":2.5,"91404":2.5,"91405":2.5,
  "91406":2.5,"91407":2.5,"91408":2.5,"91409":2.5,"91410":2.5,"91411":2.5,"91412":2.5,"100203":11.5,
  "100204":10.9,"100205":14.5,"100206":18.9,"100207":9.9,"100208":17.5,"100209":16.9,"100210":15.9,"100211":15.9,
  "100213":15.9,"100215":11.9,"100216":6.9,"100217":11.5,"100218":12.9,"100219":19.9,"100220":9.9,"100221":14.9,
  "100224":12.5,"100226":12.9,"100227":19.9,"100228":18.5,"100229":15.5,"100230":19.9,"100231":26.9,"100232":19.9,
  "100233":8.9,"100234":16.9,"100235":14.5,"100236":14.9,"100237":25.9,"100238":17.9,"100239":12.9,"100240":14.9,
  "100305":7.9,"100308":12.9,"100309":11.9,"100310":7.9,"100311":7.9,"100312":9.9,"100314":9.9,"110103":2.9,
  "120101":4.5,"120102":3.5,"120103":3.5,"120104":24.9,"150101":0.8,"150102":0.6,"150103":0.8,"150104":0.8,
  "150106":0.8,"150107":0.8,"150109":0.8,"150112":0.8,"150114":0.8,"150115":0.8,"150120":0.8,"150121":0.8,
  "150122":0.8,"150123":0.6,"150124":0.8,"150125":0.8,"150126":0.8,"150127":0.8,"150128":0.8,"150129":0.8,
  "150130":0.8,"150201":0.8,"150202":0.8,"150204":0.8,"150205":0.8,"150206":0.8,"150207":0.6,"150208":0.8,
  "150209":0.8,"150211":0.6,"210120":17,"210133":16,"210352":28.5,"210359":29,"210362":44.5,"210367":18,
  "210372":42,"210444":74,"210596":31,"210597":28,"210598":41.5,"210599":35,"250606":17,"250715":1.8,
  "250716":1.8,"251101":60,"251102":38.5,"251103":51.5,"251104":38,"251110":61,"260103":2,"260322":19.5,
  "260526":48,"260611":6.8,"260726":50.5,"260727":68,"260728":40,"260909":4.5,
};

const nombre = (v) => { const n = parseFloat(String(v == null ? "" : v).replace(",", ".")); return isNaN(n) ? 0 : n; };
const cleRef = (ref) => String(ref == null ? "" : ref).trim().replace(/^0+/, "");

// Prix catalogue d'un produit du catalogue Firestore
export function prixCatalogueDe(prod) {
  if (!prod) return 0;
  const direct = nombre(prod.prixCatalogue);
  if (direct > 0) return direct;
  const liste = PRIX_CATALOGUE[cleRef(prod.ref)];
  if (liste > 0) return liste;
  return nombre(prod.prix);
}

// Pour tout ce que voit une cliente : « prix » = prix catalogue (l'ancienne valeur est gardée dans prixEnregistre).
// Les promotions réservées aux distributrices (offre / prixOffre) ne sont pas affichées aux clientes.
export function prixClientProduit(prod) {
  if (!prod || typeof prod !== "object" || !prod.nom) return prod;
  const prix = prixCatalogueDe(prod);
  if (!(prix > 0)) return prod;
  const sortie = { ...prod, prixEnregistre: nombre(prod.prix), prix, offre: "", prixOffre: "" };
  const connu = nombre(prod.prixCatalogue) > 0 || PRIX_CATALOGUE[cleRef(prod.ref)] > 0;
  if (connu && nombre(prod.prixVIP) > 0) sortie.prixVIP = Math.round(prix * 70) / 100;
  return sortie;
}

// Applique ça à tout le document « admin/catalogue_mihi » (catégories → listes de produits)
export function prixClientCatalogue(donnees) {
  const sortie = {};
  Object.keys(donnees || {}).forEach((k) => {
    const v = donnees[k];
    sortie[k] = Array.isArray(v) ? v.map(prixClientProduit) : v;
  });
  return sortie;
}
